import '../../../../../../components/Graph/chartSetup';
import { BehaviorReductionProperties } from '../../../../../../redux/API/ClientAPIHelpers/behaviorReductionProperties';
import GraphContent from '../../../../../../components/Graph/graphContent';

interface GraphBehaviorContentProperties {
	behaviorId: string;

	data: BehaviorReductionProperties;
}

const GraphBehaviorContent = ({ data, behaviorId }: GraphBehaviorContentProperties) => (
	<GraphContent graphType="behavior" id={behaviorId} data={data} />
);

export default GraphBehaviorContent;
